import React, { useState } from 'react';

function Questionnaire() {
  const [currentStep, setCurrentStep] = useState(1);
  const [answers, setAnswers] = useState({});

  const handleAnswer = (step, answer) => {
    setAnswers(prev => ({ ...prev, [step]: answer }));

    if (step === 1) {
      switch (answer) {
        case 'route':
          setCurrentStep(2.1);
          break;
        case 'air':
          setCurrentStep(2.2);
          break;
        case 'eau':
          setCurrentStep(2.3);
          break;
        default:
          setCurrentStep(currentStep + 1);
      }
    } else if (step === 2.1) {
      switch (answer) {
        case 'voiture':
          setCurrentStep(3.1);
          break;
        case 'moto':
          setCurrentStep(3.2);
          break;
        case 'bus':
          setCurrentStep(3.3);
          break;
        default:
          setCurrentStep(currentStep + 1);
      }
    } else if (step === 2.2) {
      switch (answer) {
        case 'avion':
          setCurrentStep(3.4);
          break;
        case 'helicoptere':
          setCurrentStep(4); // Aller au résumé
          break;
        default:
          setCurrentStep(currentStep + 1);
      }
    } else if (step === 2.3) {
      switch (answer) {
        case 'bateau a moteur':
          setCurrentStep(3.5);
          break;
        case 'bateau a voile':
          setCurrentStep(3.6);
          break;
        default:
          setCurrentStep(currentStep + 1);
      }
    } else {
      setCurrentStep(4); // Aller au résumé
    }
  };

  return (
    <div>
      {currentStep === 1 && (
        <div>
          <p>Question 1: Choisissez un type de voyage</p>
          <button onClick={() => handleAnswer(1, 'route')}>Route</button>
          <button onClick={() => handleAnswer(1, 'air')}>Air</button>
          <button onClick={() => handleAnswer(1, 'eau')}>Eau</button>
        </div>
      )}
      {currentStep === 2.1 && (
        <div>
          <p>Question 2: Choisissez un véhicule pour le voyage par la route</p>
          <button onClick={() => handleAnswer(2.1, 'voiture')}>Voiture</button>
          <button onClick={() => handleAnswer(2.1, 'moto')}>Moto</button>
          <button onClick={() => handleAnswer(2.1, 'bus')}>Bus</button>
        </div>
      )}
      {currentStep === 2.2 && (
        <div>
          <p>Question 2: Choisissez un véhicule pour le voyage par les airs</p>
          <button onClick={() => handleAnswer(2.2, 'avion')}>Avion</button>
          <button onClick={() => handleAnswer(2.2, 'helicoptere')}>Hélicoptère</button>
        </div>
      )}
      {currentStep === 2.3 && (
        <div>
          <p>Question 2: Choisissez un véhicule pour le voyage par eau</p>
          <button onClick={() => handleAnswer(2.3, 'bateau a moteur')}>Bateau à moteur</button>
          <button onClick={() => handleAnswer(2.3, 'bateau a voile')}>Bateau à voile</button>
        </div>
      )}
      {currentStep === 3.1 && (
        <div>
          <p>Question 3: Type de voiture</p>
          <button onClick={() => handleAnswer(3.1, 'citadine')}>Citadine</button>
          <button onClick={() => handleAnswer(3.1, '4x4')}>4x4</button>
          <button onClick={() => handleAnswer(3.1, 'berline')}>Berline</button>
          <button onClick={() => handleAnswer(3.1, 'coupe')}>Coupé</button>
          <button onClick={() => handleAnswer(3.1, 'limousine')}>Limousine</button>
        </div>
      )}
      {currentStep === 3.2 && (
        <div>
          <p>Question 3: Type de moto</p>
          <button onClick={() => handleAnswer(3.2, 'confortable')}>Confortable</button>
          <button onClick={() => handleAnswer(3.2, 'sport')}>Sport</button>
        </div>
      )}
      {currentStep === 3.3 && (
        <div>
          <p>Question 3: Type de bus</p>
          <button onClick={() => handleAnswer(3.3, 'navette publique')}>Navette publique</button>
          <button onClick={() => handleAnswer(3.3, 'autocar')}>Autocar</button>
        </div>
      )}
      {currentStep === 3.4 && (
        <div>
          <p>Question 3: Type d'avion</p>
          <button onClick={() => handleAnswer(3.4, 'compagnie reguliere')}>Compagnie régulière</button>
          <button onClick={() => handleAnswer(3.4, 'low cost')}>Low cost</button>
          <button onClick={() => handleAnswer(3.4, 'jet prive')}>Jet privé</button>
          <button onClick={() => handleAnswer(3.4, 'avion de tourisme')}>Avion de tourisme</button>
          <button onClick={() => handleAnswer(3.4, 'planeur')}>Planeur</button>
        </div>
      )}
      {currentStep === 3.5 && (
        <div>
          <p>Question 3: Type de bateau à moteur</p>
          <button onClick={() => handleAnswer(3.5, 'hors-bord')}>Hors-bord</button>
          <button onClick={() => handleAnswer(3.5, 'yacht')}>Yacht</button>
          <button onClick={() => handleAnswer(3.5, 'overcraft')}>Overcraft</button>
        </div>
      )}
      {currentStep === 3.6 && (
        <div>
          <p>Question 3: Type de bateau à voile</p>
          <button onClick={() => handleAnswer(3.6, 'monocoque')}>Monocoque</button>
          <button onClick={() => handleAnswer(3.6, 'catamaran')}>Catamaran</button>
          <button onClick={() => handleAnswer(3.6, 'trimaran')}>Trimaran</button>
        </div>
      )}
      {currentStep === 4 && (
        <div>
          <h2>Récapitulatif</h2>
          <p>
            Vous avez choisi un voyage par <strong>{answers[1]}</strong>.
            {answers[2.1] && (<span> Ensuite, vous avez choisi un <strong>{answers[2.1]}</strong> ({answers[3.1] || answers[3.2] || answers[3.3]}).</span>)}
            {answers[2.2] && (<span> Ensuite, vous avez choisi un <strong>{answers[2.2]}</strong> ({answers[3.4] || 'hélicoptère'}).</span>)}
            {answers[2.3] && (<span> Ensuite, vous avez choisi un <strong>{answers[2.3]}</strong> ({answers[3.5] || answers[3.6]}).</span>)}
          </p>
        </div>
      )}
    </div>
  );
}

export default Questionnaire;